import {
  GetAllElectricityStatus,
  GetAllUmd,
  GetElectricityStatus,
  resetElectricityState,
  resetUmdState,
} from './../../../store/Umd/umd.actions';
import { createutilities, resetUtilitiesState } from './../../../store/Utilities/utilities.actions';
import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { utilitiesData } from './utilities-data';
import {
  SelectableSettings,
  SelectableMode,
  RemoveEvent,
} from '@progress/kendo-angular-grid';

import {
  FilterableSettings,
  DataBindingDirective,
  GridDataResult,
  PageChangeEvent,
  DataStateChangeEvent,
  GridComponent,
} from '@progress/kendo-angular-grid';
import { SVGIcon, filePdfIcon, fileExcelIcon } from '@progress/kendo-svg-icons';
import {
  FormBuilder,
  FormGroup,
  FormArray,
  AbstractControl,
} from '@angular/forms';
import Swal from 'sweetalert2';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { SharedService } from './../../../shared/shared.service';
import { LoaderService } from './../../../core/services/loader.service';
import { Store, select } from '@ngrx/store';
import { Validations } from '../../../shared/constants/validations';
import { RpCreateUMDComponent } from '../rp-create-umd/rp-create-umd.component';
import { GetUmd, deleteUmd } from '../../../store/Umd/umd.actions';
import {
  getUmdResponse,
  createUmdResponse,
  getAllUmdResponse,
  GetAllElectricitySuccessResponse,
} from '../../../store/Umd/umd-selector';
import {
  process,
  State,
  toODataString,
  SortDescriptor,
} from '@progress/kendo-data-query';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { SweetAlertIcon, UtilityType, Roles } from '../../../shared/constants/enum';
import { Helper } from '../../../core/helpers/helper';
import {
  deleteUmdResponse,
  getElectricitySuccessResponse,
} from '../../../store/Umd/umd-selector';
import {
  getutilitiesResponse,
  selectCreateutilitiesResponse,
} from '../../../store/Utilities/utilities.selector';
import { RpBulkUpoadComponent } from '../../../shared/components/rp-bulkupload/rp-bulkupload.component';
import {
  table_pageSize,
  Templates,
} from '../../../shared/constants/templatesNames';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { getutilities } from '../../../store/Utilities/utilities.actions';
import { PdfexportService } from '../../../core/services/pdfexport.service';
import { UmdService } from '../../../core/services/umd.services';
import { url } from 'node:inspector';
import { Subscription, take } from 'rxjs';
import { CdkStepper, StepperSelectionEvent } from '@angular/cdk/stepper';
import { NotificationService } from '../../../shared/notification.service';
import _ from 'lodash';

@Component({
  selector: 'app-rp-utilities',
  templateUrl: './rp-utilities.component.html',
  styleUrl: './rp-utilities.component.scss',
  standalone: false,
})
export class RpUtilitiesComponent {
  @ViewChild('cdkStepper') stepper: CdkStepper | undefined;
  selectValue!: string[];
  isAllOpen: boolean = true;

  public waterForm: FormGroup;
  public electricityForm: FormGroup;
  public triSourceForm: FormGroup;

  UtilityType = UtilityType;
  public selectableSettings!: SelectableSettings;
  public checkboxOnly = true;
  public drag = false;
  public mode: SelectableMode = 'multiple';
  public filterMode: FilterableSettings = 'row';
  public filePdfIcon: SVGIcon = filePdfIcon;
  public fileExcelIcon: SVGIcon = fileExcelIcon;
  private exportUmdSubscription: Subscription = new Subscription();
  private exportElectricitySubscription: Subscription = new Subscription();
  // file upload
  uploadSaveUrl = 'saveUrl'; // should represent an actual API endpoint
  uploadRemoveUrl = 'removeUrl'; // should represent an actual API endpoint
  @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective | undefined;
  @ViewChild(DataBindingDirective) dataBinding!: DataBindingDirective;
  @ViewChild('umdGrid') public hiddenUmdGrid: GridComponent | undefined;
  @ViewChild('electricGrid') public hiddenElectricGrid:
    | GridComponent
    | undefined;
  public gridData: unknown[] = utilitiesData;
  public gridView!: unknown[];
  utilitiesForm!: UntypedFormGroup;
  submitted: boolean = false;
  utility_gas_Validations = Validations.gas;
  utility_water_Validations = Validations.water;
  utility_electricity_Validations = Validations.electricity;
  electricityTypeItems: any;

  public pageSize = 10;
  public skip = 0;
  totalMasterCount: number = 0;
  currentPage: number = 1;
  electricitypage: number = 1;
  umdList: any[] = [];
  public sort: SortDescriptor[] = [];
  public umdgridData: GridDataResult = { data: [], total: 0 };
  public electric_city_gridData: GridDataResult = { data: [], total: 0 };
  public filter: CompositeFilterDescriptor = { logic: 'and', filters: [] };
  public electricityState: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };

  public umd_state: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };
  breadCrumbItems: Array<{}> | undefined;
  public buttonCount = 5;
  public info = true;
  public type: 'numeric' | 'input' = 'numeric';
  public pageSizes = table_pageSize.pageSizes;
  public previousNext = true;
  Roles = Roles;
  mySelectionUmd: any = [];
  myElectricTable_SelectionUmd: any = [];
  currentUser: any;
  projectId: any;
  waterTypeItems: any;
  electricityList: any = [];
  totalElectricityCount: number = 0;
  electricity_pageSize = 10;
  umdOrderByQuery: string = '';
  umdQueryString: string = '';
  umdSearchedValue: any = '';
  electricity_QueryString: string = '';
  electricity_OrderByQuery: string = '';
  electriCitySearch: any = '';
  allUmdList: any[] = [];
  allElectricityList: any[] = [];
  electricityId: any;
  waterID: any;
  gasId: any;
  getUtilitiesData: any;
  configData: any = [];
  isUploading: boolean = false;
  private mcbOnOffSubscription: Subscription;
  constructor(
    private modalService: BsModalService,
    private fb: FormBuilder,
    private formBuilder: UntypedFormBuilder,
    private loaderService: LoaderService,
    private store: Store,
    private sharedService: SharedService,
    private PdfexportService: PdfexportService,
    private umdservice: UmdService,
    private notificationService: NotificationService,
    private router: Router
  ) {
    this.loaderService.setLoading(true);
    this.getAllConfigData();
    this.breadCrumbItems = [{ label: 'Utilities' }];

    this.waterForm = this.fb.group({
      water: this.fb.array([this.addWaterGroup()]),
    });

    this.electricityForm = this.fb.group({
      electricity: this.fb.array([this.addElectricityGroup()]),
    });

    this.triSourceForm = this.fb.group({
      trisources: this.fb.array([this.addTriSourceGroup()]),
    });

    this.mcbOnOffSubscription =
      this.notificationService.mcbTurnOffOnUpdate$.subscribe((data) => {
        this.updateMcbOnOffPage(data);
      });
    // this.getStoreInfo();
  }

  public onUpload(): void {
    this.isUploading = true;
  }

  updateMcbOnOffPage(data: any) {
    this.umdSearchedValue = data;
    if (this.umdSearchedValue && this.stepper) {
      this.stepper.selectedIndex = 1;
    }
    this.getAllUmd();
    // Trigger any additional logic needed to refresh the page
  }

  public showTooltip(e: MouseEvent): void {
    const element = e.target as HTMLElement;

    // Check if the element is a table cell
    if (element.nodeName === 'TD') {
      const cellValue = element.innerText.trim();

      // Only show the tooltip if the cell is not empty, null, or ''
      if (cellValue && !element.closest('.no-tooltip')) {
        this.tooltipDir?.toggle(element);
      } else {
        this.tooltipDir?.hide();
      }
    } else if (element.classList.contains('k-column-title')) {
      this.tooltipDir?.toggle(element);
    } else {
      this.tooltipDir?.hide();
    }
  }

  umdExportAll() {
    this.store.dispatch(resetUmdState());
    this.store.dispatch(
      GetAllUmd({
        pageIndex: 1,
        pageSize: undefined,
        projectId: this.projectId,
        searchTerm: '',
        filter: '',
        orderBy: '',
      })
    );
    this.exportUmdSubscription = this.store
      .pipe(select(getAllUmdResponse))
      .pipe(take(2))
      .subscribe({
        next: (res) => {
          if (res && res?.items.length > 0) {
            this.allUmdList = [...res.items];
            const transformedData = this.allUmdList.map((item: any) => ({
              Utility: item?.utility?.name,
              'Supplier Name': item.supplierName,
              'Device Sr No': item.meterSerialNo,
              'MAC Address': item.macAddress,
              'Wired Communication Device': item.isWiredCommunicationDevice
                ? 'Yes'
                : 'No',
              'Gateway Serial Number': item.gatewayName,
              'Meter Stats': item.status,
              'Valve Relay Status': item.valveRelayStatus ? 'ON' : 'OFF',
            }));
            this.PdfexportService.downloadExcel(transformedData, 'Umd');
          } else if (res != null) {
            this.sharedService.showMessageDialog(
              'No data to display',
              '',
              SweetAlertIcon.ERROR
            );
          }

          console.log('getAllUmdResponse', res, this.umdList);
        },
        error: (err) => {
          console.log(err);
        },
      });
    //this.getAllTotalUmd();
  }
  electricCityExportAll() {
    this.GetAllElectricityStatus();
    this.exportElectricitySubscription = this.store
      .pipe(select(GetAllElectricitySuccessResponse))
      .pipe(take(2))
      .subscribe({
        next: (res) => {
          if (res && res?.items.length > 0) {
            this.allElectricityList = [...res.items];
            const transformedData = this.allElectricityList.map(
              (item: any) => ({
                'MAC Address': item.macAddress,
                'Device Sr No': item.meterSerialNo,
                'Eb Dg Shift Status': item.ebDgShiftStatus,
                'Eb Dg Shift values': item.ebDgShiftValue,
                Date: this.sharedService.dateFormateChnage(item.date),
              })
            );
            this.PdfexportService.downloadExcel(transformedData, 'Electricity');
          } else if (res != null) {
            this.sharedService.showMessageDialog(
              'No data to display',
              '',
              SweetAlertIcon.ERROR
            );
          }
          console.log('umdList', res, this.allElectricityList);
        },
      });
  }

  getStoreInfo() {
    this.store.dispatch(resetUmdState());
    this.store.dispatch(resetElectricityState());
    let getUtilities$ = this.store.pipe(select(getutilitiesResponse));
    let getUmd$ = this.store.pipe(select(getUmdResponse));
    //let getAllUmdResponse$ = this.store.pipe(select(getAllUmdResponse));
    let createUmdResponse$ = this.store.pipe(select(createUmdResponse));
    let deleteUmdResponse$ = this.store.pipe(select(deleteUmdResponse));

    // let getUtilities$ = this.store.pipe(select(getutilitiesResponse));
    getUtilities$.subscribe((res: any) => {
      this.getUtilitiesData = [];
      if (res && res.statusCode === 200) {
        // this.getUtilitiesData = [];
        this.getUtilitiesData = res.data;
        console.log(this.getUtilitiesData);
        console.log(this.utilitiesForm);
        if (this.utilitiesForm) {
          let gasFile = this.getUtilitiesData?.gas?.gasFile?.fileName
            ? [
                {
                  name: this.getUtilitiesData?.gas?.gasFile?.fileName,
                  src: this.getUtilitiesData?.gas?.gasFile?.fileUrl,
                  size: this.getUtilitiesData?.gas?.gasFile?.fileSize,
                  uid: this.getUtilitiesData?.gas?.gasFile?.id,
                },
              ]
            : [];

          let waterFile = this.getUtilitiesData?.water[0]?.waterFile?.fileName
            ? [
                {
                  name: this.getUtilitiesData?.water[0]?.waterFile?.fileName,
                  src: this.getUtilitiesData?.water[0]?.waterFile?.fileUrl,
                  size: this.getUtilitiesData?.water[0]?.waterFile?.fileSize,
                  uid: this.getUtilitiesData?.water[0]?.waterFile?.id,
                },
              ]
            : [];

          let electricityFile = this.getUtilitiesData?.electricity[0]
            ?.electricityFile?.fileName
            ? [
                {
                  name: this.getUtilitiesData?.electricity[0]?.electricityFile
                    ?.fileName,
                  src: this.getUtilitiesData?.electricity[0]?.electricityFile
                    ?.fileUrl,
                  size: this.getUtilitiesData?.electricity[0]?.electricityFile
                    ?.fileSize,
                  uid: this.getUtilitiesData?.electricity[0]?.electricityFile
                    ?.id,
                  url: this.getUtilitiesData?.electricity[0]?.electricityFile
                    ?.fileUrl,
                },
              ]
            : [];
          let triSourceFile = this.getUtilitiesData?.triSource[0]?.triSourceFile
            ?.fileName
            ? [
                {
                  name: this.getUtilitiesData?.triSource[0]?.triSourceFile
                    ?.fileName,
                  src: this.getUtilitiesData?.triSource[0]?.triSourceFile
                    ?.fileUrl,
                  size: this.getUtilitiesData?.triSource[0]?.triSourceFile
                    ?.fileSize,
                  uid: this.getUtilitiesData?.triSource[0]?.triSourceFile?.id,
                  url: this.getUtilitiesData?.triSource[0]?.triSourceFile
                    ?.fileUrl,
                },
              ]
            : [];

          console.log(this.getUtilitiesData.triSource);
          console.log(triSourceFile);

          if (this.getUtilitiesData?.gas) {
            this.utilitiesForm.patchValue({
              gas: {
                utilityMasterId: this.getUtilitiesData?.gas?.utilityMasterId,
                gasValue: this.getUtilitiesData?.gas?.gasValue,
                UnitLPGValue: this.getUtilitiesData?.gas?.unitLPGValue,
                unitPrice: this.getUtilitiesData?.gas?.unitPrice,
                File: gasFile,
              },
            });
          }
          if (this.getUtilitiesData?.water.length > 0) {
            this.utilitiesForm.patchValue({
              WaterFile: waterFile,
            });
          }
          if (this.getUtilitiesData?.electricity.length > 0) {
            this.utilitiesForm.patchValue({
              ElectricityFile: electricityFile,
            });
          }

          if (this.getUtilitiesData?.triSource.length > 0) {
            this.utilitiesForm.patchValue({
              triSourceFile: triSourceFile,
            });
          }
          this.utilitiesForm.patchValue({
            projectId: this.getUtilitiesData?.projectId,
            // gas: {
            //   utilityMasterId: this.getUtilitiesData?.gas?.utilityMasterId,
            //   gasValue: this.getUtilitiesData?.gas?.gasValue,
            //   UnitLPGValue: this.getUtilitiesData?.gas?.unitLPGValue,
            //   unitPrice: this.getUtilitiesData?.gas?.unitPrice,
            //   File: gasFile,
            // },
            // WaterFile: waterFile,
            // ElectricityFile: electricityFile,
          });

          // Clear and update the water FormArray
          let waterArray = this.utilitiesForm.get('water') as FormArray;
          waterArray.clear(); // Clear all existing controls

          this.getUtilitiesData?.water.forEach((waterItem: any) => {
            if (waterItem.slabName != null) {
              waterArray.push(
                this.fb.group({
                  id: [waterItem.id],
                  utilityMasterId: [waterItem.utilityMasterId || this.waterID],
                  slabName: [waterItem.slabName, Validators.required],
                  MinValue: [
                    waterItem.minValue,
                    [
                      Validators.required,
                      Helper.PatternValidator(/^(0|[1-9]\d*)(\.\d+)?$/),
                    ],
                  ],
                  MaxValue: [
                    waterItem.maxValue,
                    [
                      Validators.required,
                      Helper.PatternValidator(/^(0|[1-9]\d*)(\.\d+)?$/),
                    ],
                  ],
                  unitPrice: [
                    waterItem.unitPrice,
                    [
                      Validators.required,
                      Helper.maxValueValidator(99999),
                      Helper.PatternValidator(
                        /^(?!0+(\.0+)?$)([1-9]\d*|0)?(\.\d+)?$/
                      ),
                    ],
                  ],
                })
              );
            }
          });

          // Clear and update the electricity FormArray
          let electricityArray = this.utilitiesForm.get(
            'electricity'
          ) as FormArray;
          electricityArray.clear(); // Clear all existing controls

          this.getUtilitiesData?.electricity.forEach((electricityItem: any) => {
            if (electricityItem.slabName != null) {
              electricityArray.push(
                this.fb.group({
                  id: [electricityItem.id],
                  utilityMasterId: [
                    electricityItem.utilityMasterId || this.electricityId,
                  ],
                  slabName: [electricityItem.slabName, Validators.required],
                  minKwh: [
                    electricityItem.minKwh,
                    [
                      Validators.required,
                      Helper.PatternValidator(/^(0|[1-9]\d*)(\.\d+)?$/),
                    ],
                  ],
                  maxKwh: [
                    electricityItem.maxKwh,
                    [
                      Validators.required,
                      Helper.PatternValidator(/^(0|[1-9]\d*)(\.\d+)?$/),
                    ],
                  ],
                  unitPrice: [
                    electricityItem.unitPrice,
                    [
                      Validators.required,
                      Helper.maxValueValidator(99999),
                      Helper.PatternValidator(
                        /^(?!0+(\.0+)?$)([1-9]\d*|0)?(\.\d+)?$/
                      ),
                    ],
                  ],
                })
              );
            }
          });

          // Clear and update the TriSource FormArray
          let TriSourceArray = this.utilitiesForm.get(
            'trisources'
          ) as FormArray;
          TriSourceArray.clear(); // Clear all existing controls

          this.getUtilitiesData?.triSource.forEach((triSourceItem: any) => {
            if (triSourceItem.slabName != null) {
              TriSourceArray.push(
                this.fb.group({
                  id: [triSourceItem.id],
                  utilityMasterId: [
                    triSourceItem.utilityMasterId || this.triSourceId,
                  ],
                  slabName: [triSourceItem.slabName, Validators.required],
                  minKwh: [
                    triSourceItem.minKwh,
                    [
                      Validators.required,
                      Helper.PatternValidator(/^(0|[1-9]\d*)(\.\d+)?$/),
                    ],
                  ],
                  maxKwh: [
                    triSourceItem.maxKwh,
                    [
                      Validators.required,
                      Helper.PatternValidator(/^(0|[1-9]\d*)(\.\d+)?$/),
                    ],
                  ],
                  unitPrice: [
                    triSourceItem.unitPrice,
                    [
                      Validators.required,
                      Helper.maxValueValidator(99999),
                      Helper.PatternValidator(/^(0|[1-9]\d*)(\.\d+)?$/),
                    ],
                  ],
                })
              );
            }
          });

          if (
            this.selectedIndex == 0 &&
            Object.keys(this.getUtilitiesData).length > 0 &&
            this.utilitiesForm
          ) {
            this.loaderService.setLoading(false);
          }
        }
      } else {
        console.log('responseprofile');
        this.loaderService.setLoading(false);
      }
      // console.log('responseprofile', res);
      // console.log('responseprofile', this.selectedIndex);
      // console.log('responseprofile', this.getUtilitiesData.length);
    });

    let Createutilitiesuccess$ = this.store.pipe(
      select(selectCreateutilitiesResponse)
    );
    let GetElectricitySuccessStatus$ = this.store.pipe(
      select(getElectricitySuccessResponse)
    );

    let GetAllElectricitySuccessResponse$ = this.store.pipe(
      select(GetAllElectricitySuccessResponse)
    );

    getUmd$.subscribe(
      (res: any) => {
        if (res) {
          this.umdList = [...res.items];
          this.pageSize = res.pageSize;
          this.totalMasterCount = res.totalCount;
          this.loadUmd();
        } else {
          this.loaderService.setLoading(false);
        }

        console.log('umdList', res, this.umdList);
      },
      (error) => {
        this.loaderService.setLoading(false);
      }
    );

    /*   getAllUmdResponse$.subscribe((res: any) => {
       
      }); */

    Createutilitiesuccess$.subscribe(
      (res: any) => {
        if (res && res.statusCode == 201) {
          // this.utilitiesForm.reset();
          // this.clearValidationStates(this.utilitiesForm);
          this.getUtilities();
        } else {
          this.loaderService.setLoading(false);
        }
        console.log('uuu', res);
      },
      (error) => {
        this.loaderService.setLoading(false);
      }
    );

    GetElectricitySuccessStatus$.subscribe((res: any) => {
      if (res) {
        this.electricityList = [...res.items];
        this.electricity_pageSize = res.pageSize;
        this.totalElectricityCount = res.totalCount;
      }
      this.loadElectricCity();
      console.log('umdList', res, this.umdList);
    });

    deleteUmdResponse$.subscribe((res: any) => {
      if (res) {
        this.getAllUmd();
      }
      console.log('umdList', res, this.umdList);
    });

    createUmdResponse$.subscribe((res: any) => {
      if (res) {
        this.getAllUmd();
      }
      console.log('umdList', res, this.umdList);
    });
  }

  downloadFile(file: string, fileName: string) {
    this.sharedService.downloadUtilityFiles(file, fileName);
  }
  clearValidationStates(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((controlName) => {
      const control = formGroup.get(controlName);
      if (control) {
        formGroup.reset();
      }
    });
  }

  private loadUmd(): void {
    const state: State = {
      take: this.pageSize,
      sort: this.sort,
      // filter: this.filter,
      filter: {
        logic: 'and',
        filters: [],
      } as CompositeFilterDescriptor,
    };
    // console.log(this.umdList)
    const processedData = process(this.umdList, state);
    // console.log(processedData)
    this.umdgridData = {
      data: processedData.data,
      total: this.totalMasterCount,
    };

    this.umdgridData.data = this.umdgridData.data.map((item) => {
      return {
        ...item,
        wirdeCommunication:
          item?.isWiredCommunicationDevice == true ? 'Yes' : 'No',
        valveRelayStatus: item?.valveRelayStatus == true ? 'ON' : 'OFF',
      };
    });
    this.loaderService.setLoading(false);
  }

  getUtilities() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') ?? '');
    this.projectId = this.currentUser?.project.id;
    this.store.dispatch(getutilities({ projectId: this.projectId }));
  }

  loadElectricCity(): void {
    const state: State = {
      take: this.electricity_pageSize,
      sort: this.sort,
      // filter: this.filter,
      filter: {
        logic: 'and',
        filters: [],
      } as CompositeFilterDescriptor,
    };

    const processedData = process(this.electricityList, state);

    this.electric_city_gridData = {
      data: processedData.data,
      total: this.totalElectricityCount,
    };
    this.electric_city_gridData.data = this.electric_city_gridData.data.map(
      (project) => {
        console.log(new Date(project.date));
        return {
          ...project,
          dateFormate: this.sharedService.dateFormateChnage(project.date), // Modify the billDate property
        };
      }
    );
    this.loaderService.setLoading(false);
  }

  modalRef!: BsModalRef;
  config: any = {
    backdrop: true,
    ignoreBackdropClick: true,
  };

  deleteUtilities() {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-primary ms-2',
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          swalWithBootstrapButtons.fire(
            'Deleted!',
            'Your file has been deleted.',
            'success'
          );
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          swalWithBootstrapButtons.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }
  //Append Fields Set
  private addWaterGroup(): FormGroup {
    return this.fb.group({
      slabName: [],
      min: [],
      max: [],
      slabPerUnit: [],
      unitPrice: [],
    });
  }

  //Add Fields

  //Append Fields Set
  private addElectricityGroup(): FormGroup {
    return this.fb.group({
      slabName: [],
      minKwh: [],
      maxKwh: [],
      unitPrice: [],
    });
  }

  private addTriSourceGroup(): FormGroup {
    return this.fb.group({
      slabName: [],
      minKwh: [],
      maxKwh: [],
      unitPrice: [],
    });
  }

  /**
   * Open center modal
   * @param bulkUploadModal
   */
  bulkUploadModal(bulkUploadModal: any) {
    this.modalRef = this.modalService.show(bulkUploadModal);
  }

  /**
   * Open center modal
   * @param addUmdModal center modal data
   */
  addUmdModal(addUmdModal: any) {
    this.modalRef = this.modalService.show(addUmdModal);
  }
  editUmd(data: any) {
    console.log(data);
    if (this.isEVUmd(data)) {
      this.router.navigate(['/utilities/createEVMeter'], {
        state: { umdData: data, configData: this.configData },
      });
      return;
    }

    let umdData = data;
    let configData = this.configData;
    this.modalRef = this.modalService.show(RpCreateUMDComponent, {
      initialState: { umdData, configData },
      ...this.config,
    });
  }

  deleteUmd(dataItem: any) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-primary ms-2',
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        showCancelButton: true,
      })
      .then((result) => {
        console.log(result.value);
        if (result.value) {
          this.store.dispatch(deleteUmd({ id: dataItem.id }));
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          swalWithBootstrapButtons.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            SweetAlertIcon.INFO
          );
        }
      });
  }

  // onStepChange(event: any): void {
  //   if(this.stepper)
  //   alert(this.stepper.selectedIndex)
  //   this.store.dispatch(resetElectricityState());
  // }
  selectedIndex: number = 0;
  onStepChange(event: StepperSelectionEvent): void {
    this.loaderService.setLoading(true);

    this.selectedIndex = event.selectedIndex;
    console.log('Selected step index:', this.selectedIndex);

    // Perform any action based on the selected index
    if (this.selectedIndex === 0) {
      this.getUtilities();
      // Code for when step 0 is selected
    }
    if (this.selectedIndex === 1) {
      this.getAllUmd();
    }
    if (this.selectedIndex === 2) {
      this.GetElectricityStatus();
    }
  }
  ngOnDestroy() {
    if (this.mcbOnOffSubscription) {
      this.mcbOnOffSubscription.unsubscribe();
    }
    this.exportUmdSubscription.unsubscribe();
  }
  ngOnInit(): void {
    this.loaderService.setLoading(true);
    this.store.dispatch(resetUtilitiesState());
    this.selectableSettings = {
      checkboxOnly: this.checkboxOnly,
      mode: this.mode,
      drag: this.drag,
    };
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') ?? '');
    console.log(this.currentUser);
    if (history.state?.selectedIndex !== undefined) {
      setTimeout(() => {
        if (this.stepper) {
          this.stepper.selectedIndex = history.state.selectedIndex;
          if (history.state.selectedIndex === 1) {
            this.getAllUmd();
          }
        }
      });
    }

    this.projectId = this.currentUser?.project.id;

    const hasGas = this.isUtilityDisplay('Gas');
    const hasWater = this.isUtilityDisplay('Water');
    const hasElectricity = this.isUtilityDisplay('Electricity');

    this.umdSearchedValue = history.state.info ?? '';

    this.utilitiesForm = this.formBuilder.group({
      projectId: this.projectId,
      gas: this.formBuilder.group({
        utilityMasterId: hasGas ? this.gasId : '',
        gasValue: [
          { value: '', disabled: !hasGas },
          hasGas
            ? [
                Validators.required,
                Validators.minLength(1),
                Validators.maxLength(20),
                Helper.PatternValidator(/^(0|[1-9]\d*)(\.\d+)?$/),
              ]
            : [],
        ],
        UnitLPGValue: [
          { value: '', disabled: !hasGas },
          hasGas
            ? [
                Validators.required,
                Helper.PatternValidator(/^(0|[1-9]\d*)(\.\d+)?$/),
              ]
            : [],
        ],
        unitPrice: [
          { value: '', disabled: !hasGas },
          hasGas
            ? [
                Validators.required,
                Helper.maxValueValidator(99999),
                Helper.PatternValidator(
                  /^(?!0+(\.0+)?$)([1-9]\d*|0)?(\.\d+)?$/
                ),
              ]
            : [],
        ],
        File: [],
      }),
      water: this.formBuilder.array(hasWater ? [this.createWaterGroup()] : []),
      electricity: this.formBuilder.array(
        hasElectricity ? [this.createElectricityGroup()] : []
      ),
      trisources: this.formBuilder.array(
        hasElectricity ? [this.createTriSourceGroup()] : []
      ),
      WaterFile: null,
      ElectricityFile: null,
      triSourceFile: null,
      removedUtilityIds: this.formBuilder.array([]),
      IsGasFileDeleted: false,
      IsWaterFileDeleted: false,
      IsTriSourceFileDeleted: false,
      IsElectricityFileDeleted: false,
    });

    this.utilitiesForm
      .get('gas.gasValue')
      ?.valueChanges.subscribe(() => this.calculateUnitPrice());
    this.utilitiesForm
      .get('gas.UnitLPGValue')
      ?.valueChanges.subscribe(() => this.calculateUnitPrice());
    // this.utilitiesForm.get('gas.unitPrice')?.disable();
    this.getUtilities();

    // this.getAllUmd();
    // this.GetElectricityStatus();
  }

  public ElectricityStatusValueChange(ev: string): void {
    const trimmedValue = ev.trim();

    // If user enters only spaces — do nothing (just keep the clear icon visible)
    if (trimmedValue.length === 0 && ev.length > 0) {
      return;
    }

    // If user cleared the box (either manually or by clicking the clear icon)
    if (ev.length === 0) {
      this.electricCityPageChange({ skip: 0, take: this.electricity_pageSize });
      //  this.getUsersData();
    } 
   /*  if (ev.length == 0) {
      this.electricCityPageChange({ skip: 0, take: this.electricity_pageSize });
      this.GetElectricityStatus();
    } */
  }
  private triggerSearchele(): void {
    const trimmedValue = this.electriCitySearch.trim();

    // If only spaces — do nothing
    if (trimmedValue.length === 0 && this.electriCitySearch.length > 0) {
      return;
    }

    // If empty — load previous data
    if (this.electriCitySearch.length === 0) {
      this.electricCityPageChange({ skip: 0, take: this.electricity_pageSize });
      this.GetElectricityStatus();
      return;
    }

    // Otherwise — run search
   this.GetElectricityStatus();
  }
  public UmdValueChange(ev: string): void {
    const trimmedValue = ev.trim();

    // If user enters only spaces — do nothing (just keep the clear icon visible)
    if (trimmedValue.length === 0 && ev.length > 0) {
      return;
    }

    // If user cleared the box (either manually or by clicking the clear icon)
    if (ev.length === 0) {
      this.umdPageChange({ skip: 0, take: this.pageSize });
      //  this.getUsersData();
    }
    /* if (ev.length == 0) {
      this.umdPageChange({ skip: 0, take: this.pageSize });
      this.getAllUmd();
    } */
  }
  private triggerSearch(): void {
    const trimmedValue = this.umdSearchedValue.trim();

    // If only spaces — do nothing
    if (trimmedValue.length === 0 && this.umdSearchedValue.length > 0) {
      return;
    }

    // If empty — load previous data
    if (this.umdSearchedValue.length === 0) {
      this.umdPageChange({ skip: 0, take: this.pageSize });
      this.getAllUmd();
      return;
    }

    // Otherwise — run search
    this.getAllUmd();
  }
  onSearchUmdDevices(): void {
    this.triggerSearch();
    /*  if (this.umdSearchedValue.length > 0) {
      this.getAllUmd();
    } */
  }

  ngAfterViewInit() {
    if (this.umdSearchedValue && this.stepper) {
      this.stepper.selectedIndex = 1;
    }
  }

  onGasValueBlur(event: any) {
    const value = event.target.value;
    if (value && !isNaN(value)) {
      // Round to two decimal places and update the form control value
      const roundedValue = parseFloat(value).toFixed(2);
      // this.utilitiesForm.controls['gasValue'].patch(roundedValue);
      this.utilitiesForm.patchValue({
        gas: {
          gasValue: roundedValue,
        },
      });
    }
  }
  onGasInput(event: any) {
    const input = event.target as HTMLInputElement;
    const val = input.value;

    // Replace anything that breaks the 5-digit-before-decimal rule
    const regex = /^(\d{0,5})(\.\d*)?$/;

    if (!regex.test(val)) {
      // Trim the input
      const match = val.match(/^(\d{0,5})/);
      const integerPart = match ? match[1] : '';
      const decimalPart = val.split('.')[1] || '';
      input.value = integerPart + (decimalPart ? '.' + decimalPart : '');
    }
  }

  onWaterInput(event: any) {
    const input = event.target as HTMLInputElement;
    const val = input.value;

    // Replace anything that breaks the 5-digit-before-decimal rule
    const regex = /^(\d{0,25})(\.\d*)?$/;

    if (!regex.test(val)) {
      // Trim the input
      const match = val.match(/^(\d{0,25})/);
      const integerPart = match ? match[1] : '';
      const decimalPart = val.split('.')[1] || '';
      input.value = integerPart + (decimalPart ? '.' + decimalPart : '');
    }
  }
  oneleInput(event: any) {
    const input = event.target as HTMLInputElement;
    const val = input.value;

    // Replace anything that breaks the 5-digit-before-decimal rule
    const regex = /^(\d{0,25})(\.\d*)?$/;

    if (!regex.test(val)) {
      // Trim the input
      const match = val.match(/^(\d{0,25})/);
      const integerPart = match ? match[1] : '';
      const decimalPart = val.split('.')[1] || '';
      input.value = integerPart + (decimalPart ? '.' + decimalPart : '');
    }
  }

  onWaterValueBlur(event: any, index: number) {
    const inputValue = event.target.value;

    if (inputValue) {
      // Parse the input value to a float and round it to 2 decimal places
      const roundedValue = parseFloat(inputValue).toFixed(3);

      // Set the rounded value back to the form control
      const waterArray = this.waterForm.get('water') as FormArray;
      this.waterArray.at(index).get('unitPrice')?.patchValue(roundedValue);
    }
  }

  isUtilityDisplay(type: string): boolean {
    const projectUtilities =
      this.currentUser?.projectUtilities ??
      this.currentUser?.project?.projectUtilities ??
      this.currentUser?.project?.ProjectUtilities ??
      this.currentUser?.project?.selectedUtilities ??
      this.currentUser?.project?.SelectedUtilities ??
      this.currentUser?.project?.utilities ??
      this.currentUser?.project?.Utilities ??
      [];
    const utility = Array.isArray(projectUtilities)
      ? projectUtilities.find((u: any) => {
          const name =
            u?.name ??
            u?.Name ??
            u?.utilityName ??
            u?.UtilityName ??
            u?.master?.name ??
            u?.Master?.Name ??
            u;

          return (
            name?.toString().trim().toLowerCase() ===
            type.trim().toLowerCase()
          );
        })
      : null;
    return !!utility; // Returns true if 'Electricity' is found, false otherwise
  }

  isEVUmd(dataItem: any): boolean {
    return (
      dataItem?.utility?.name?.toString().trim().toLowerCase() ===
      UtilityType.EV.toLowerCase()
    );
  }

  addEVMeter(): void {
    this.router.navigate(['/utilities/createEVMeter'], {
      state: { configData: this.configData },
    });
  }

  private calculateUnitPrice(): void {
    const gasValue = this.utilitiesForm.get('gas.gasValue')?.value;
    const UnitLPGValue = this.utilitiesForm.get('gas.UnitLPGValue')?.value;

    // Check if both values are valid and are not empty strings
    if (gasValue && UnitLPGValue && !isNaN(gasValue) && !isNaN(UnitLPGValue)) {
      // Parse values to ensure they are treated as numbers
      const unitPrice = parseFloat(gasValue) * parseFloat(UnitLPGValue);

      // Log the value and its type to confirm
      console.log(unitPrice + ' ---- ' + typeof unitPrice);

      // If you want to round the result to 2 decimal places
      const roundedUnitPrice = unitPrice.toFixed(2);
      // Ensure the unitPrice is updated correctly
      this.utilitiesForm
        .get('gas.unitPrice')
        ?.setValue(roundedUnitPrice.toString(), { emitEvent: false });
    } else {
      // Reset unitPrice if inputs are invalid or empty
      this.utilitiesForm
        .get('gas.unitPrice')
        ?.setValue('', { emitEvent: false });
    }

    console.log(this.utilitiesForm.value);
  }

  public onUmdFilter(value: any): void {
    this.triggerSearch();
    /* this.loaderService.setLoading;
    this.umdPageChange({ skip: 0, take: this.pageSize });
    this.getAllUmd(); */
  }

  public onElectricFilter(value: any): void {
    this.triggerSearchele()
   /*  this.loaderService.setLoading(true);
    this.electricCityPageChange({ skip: 0, take: this.electricity_pageSize });
    this.GetElectricityStatus(); */
  }

  GetElectricityStatus() {
    console.log(this.electricity_QueryString);

    this.store.dispatch(
      GetElectricityStatus({
        pageIndex: this.electricitypage,
        pageSize: this.electricity_pageSize,
        projectId: this.projectId,
        searchTerm: this.electriCitySearch,
        filter: this.electricity_QueryString,
        orderBy: this.electricity_OrderByQuery,
      })
    );
  }

  GetAllElectricityStatus() {
    this.store.dispatch(
      GetAllElectricityStatus({
        pageIndex: this.electricitypage,
        pageSize: undefined,
        projectId: this.projectId,
        searchTerm: '',
        filter: '',
        orderBy: '',
      })
    );
  }

  getAllUmd() {
    this.store.dispatch(
      GetUmd({
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        projectId: this.projectId,
        searchTerm: this.umdSearchedValue,
        filter: this.umdQueryString,
        orderBy: this.umdOrderByQuery,
      })
    );
  }

  getAllTotalUmd() {
    this.store.dispatch(
      GetAllUmd({
        pageIndex: this.currentPage,
        pageSize: undefined,
        projectId: this.projectId,
        searchTerm: '',
        filter: '',
        orderBy: '',
      })
    );
  }

  createWaterGroup(): UntypedFormGroup {
    return this.formBuilder.group({
      id: '',
      utilityMasterId: this.waterID,
      slabName: [null, Validators.required],
      MinValue: [
        '',
        [
          Validators.required,
          Helper.PatternValidator(/^(0|[1-9]\d*)(\.\d+)?$/),
        ],
      ],
      MaxValue: [
        '',
        [
          Validators.required,
          Helper.PatternValidator(/^(0|[1-9]\d*)(\.\d+)?$/),
        ],
      ],
      unitPrice: [
        '',
        [
          Validators.required,
          Helper.maxValueValidator(99999),
          Helper.PatternValidator(/^(?!0+(\.0+)?$)([1-9]\d*|0)?(\.\d+)?$/),
        ],
      ],
    });
  }

  getAllConfigData(): void {
    let payload = ['suppliers', 'utilities', 'statuses'];
    this.loaderService.setLoading(true);
    this.sharedService.getAllConfigData(payload).subscribe((res) => {
      if (
        res.statusCode === 200 &&
        res.message === 'Config data retrieved successfully.'
      ) {
        this.configData = res.data;

        // Filter suppliers based on utility type
        this.electricityTypeItems = res?.data?.suppliers.filter(
          (item: any) => item.master.name === 'Electricity'
        );
        this.waterTypeItems = res?.data?.suppliers.filter(
          (item: any) => item.master.name === 'Water'
        );
        this.triSourceItems = res?.data?.suppliers.filter((data: any) => {
          console.log(data.master.name); // Check value of `name` before filtering
          return data.master.name.trim().toLowerCase() === 'trisource'; // Case insensitive comparison
        });

        console.log(this.waterTypeItems);

        // Set utility IDs and patch values for respective form groups
        res?.data?.utilities.forEach((item: any) => {
          switch (item?.name) {
            case 'Electricity':
              this.electricityId = item.id;
              this.patchUtilityArray('electricity', this.electricityId);
              break;
            case 'TriSource':
              this.triSourceId = item.id;
              this.patchUtilityArray('trisources', this.triSourceId);
              break;
            case 'Water':
              this.waterID = item.id;
              this.patchUtilityArray('water', this.waterID);
              break;
            case 'Gas':
              this.gasId = item.id;
              this.utilitiesForm.get('gas')?.patchValue({
                utilityMasterId: this.gasId,
              });
              break;
          }
        });

        console.log(this.utilitiesForm.value);

        // Additional actions after setting the utility IDs
        this.getStoreInfo();
      }
    });
  }

  // Helper method to patch utility ID for form arrays
  private patchUtilityArray(
    formArrayName: string,
    utilityMasterId: string
  ): void {
    const formArray = this.utilitiesForm.get(formArrayName) as FormArray;
    formArray.controls.forEach((control: AbstractControl) => {
      (control as FormGroup).patchValue({
        utilityMasterId: utilityMasterId.toString(),
      });
    });
  }

  private ensureUtilityMasterIds(utilitiesData: any): any {
    return {
      ...utilitiesData,
      water: (utilitiesData.water ?? []).map((item: any) => ({
        ...item,
        utilityMasterId: item.utilityMasterId || this.waterID,
      })),
      electricity: (utilitiesData.electricity ?? []).map((item: any) => ({
        ...item,
        utilityMasterId: item.utilityMasterId || this.electricityId,
      })),
      trisources: (utilitiesData.trisources ?? []).map((item: any) => ({
        ...item,
        utilityMasterId: item.utilityMasterId || this.triSourceId,
      })),
    };
  }

  createElectricityGroup(): UntypedFormGroup {
    return this.formBuilder.group({
      utilityMasterId: this.electricityId,
      slabName: [null, Validators.required],
      minKwh: [
        '',
        [
          Validators.required,
          Helper.PatternValidator(/^(0|[1-9]\d*)(\.\d+)?$/),
        ],
      ],
      maxKwh: [
        '',
        [
          Validators.required,
          Helper.PatternValidator(/^(0|[1-9]\d*)(\.\d+)?$/),
        ],
      ],
      unitPrice: [
        '',
        [
          Validators.required,
          Helper.maxValueValidator(99999),
          Helper.PatternValidator(/^(?!0+(\.0+)?$)([1-9]\d*|0)?(\.\d+)?$/),
        ],
      ],
    });
  }
  triSourceId: any;
  createTriSourceGroup(): UntypedFormGroup {
    return this.formBuilder.group({
      utilityMasterId: this.triSourceId,
      slabName: [null, Validators.required],
      minKwh: [
        '',
        [
          Validators.required,
          Helper.PatternValidator(/^(0|[1-9]\d*)(\.\d+)?$/),
        ],
      ],
      maxKwh: [
        '',
        [
          Validators.required,
          Helper.PatternValidator(/^(0|[1-9]\d*)(\.\d+)?$/),
        ],
      ],
      unitPrice: [
        '',
        [
          Validators.required,
          Helper.maxValueValidator(99999),
          Helper.PatternValidator(/^(?!0(\.0+)?$)(0|[1-9]\d*)(\.\d+)?$/),
        ],
      ],
    });
  }

  get gasForm() {
    return this.utilitiesForm.get('gas') as FormGroup;
  }

  get waterArray(): FormArray {
    return this.utilitiesForm.get('water') as FormArray;
  }

  get electricityArray(): FormArray {
    return this.utilitiesForm.get('electricity') as FormArray;
  }

  get triSourceArray(): FormArray {
    return this.utilitiesForm.get('trisources') as FormArray;
  }

  addWater(): void {
    this.waterArray.push(this.createWaterGroup());
  }

  removeWater(index: number): void {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-primary ms-2',
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          const removedUtilityIdsArray = this.utilitiesForm.get(
            'removedUtilityIds'
          ) as FormArray;
          const control = this.waterArray.at(index) as FormGroup;

          // Get the ID from the FormGroup
          const id = control.get('id')?.value;

          // Check if the ID is not null or empty and push to removedUtilityIds
          if (id && id !== '') {
            removedUtilityIdsArray.push(this.formBuilder.control(id));
          }
          this.waterArray.removeAt(index);
          /*  swalWithBootstrapButtons.fire(
             'Deleted!',
             'Your file has been deleted.',
             'success'
           ); */
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          /*  swalWithBootstrapButtons.fire(
             'Cancelled',
             'Your imaginary file is safe :)',
             'error'
           ); */
        }
      });
  }

  addElectricity(): void {
    this.electricityArray.push(this.createElectricityGroup());
  }

  addETriSource(): void {
    this.triSourceArray.push(this.createTriSourceGroup());
  }

  removeElectricity(index: number): void {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-primary ms-2',
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          const removedUtilityIdsArray = this.utilitiesForm.get(
            'removedUtilityIds'
          ) as FormArray;
          const control = this.electricityArray.at(index) as FormGroup;

          // Get the ID from the FormGroup
          const id = control.get('id')?.value;

          // Check if the ID is not null or empty and push to removedUtilityIds
          if (id && id !== '') {
            removedUtilityIdsArray.push(this.formBuilder.control(id));
          }
          this.electricityArray.removeAt(index);
          /*  swalWithBootstrapButtons.fire(
             'Deleted!',
             'Your file has been deleted.',
             'success'
           ); */
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
        }
      });
  }
  removeTriSource(index: number): void {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-primary ms-2',
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          const removedUtilityIdsArray = this.utilitiesForm.get(
            'removedUtilityIds'
          ) as FormArray;
          const control = this.triSourceArray.at(index) as FormGroup;

          // Get the ID from the FormGroup
          const id = control.get('id')?.value;

          // Check if the ID is not null or empty and push to removedUtilityIds
          if (id && id !== '') {
            removedUtilityIdsArray.push(this.formBuilder.control(id));
          }
          this.triSourceArray.removeAt(index);
          /*  swalWithBootstrapButtons.fire(
             'Deleted!',
             'Your file has been deleted.',
             'success'
           ); */
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
        }
      });
  }

  validateSlabData(
    slabData: any[],
    supplierTypeItems: any[],
    minProp: string,
    maxProp: string
  ): boolean {
    // Create a map to lookup names by their ID
    const nameMap = supplierTypeItems.reduce(
      (map: { [id: string]: string }, item: any) => {
        map[item.id] = item.name;
        return map;
      },
      {}
    );

    // Group slabs by slabName
    const slabGroups: { [key: string]: any[] } = {};

    slabData.forEach((slab) => {
      const { slabName } = slab;
      if (!slabGroups[slabName]) {
        slabGroups[slabName] = [];
      }
      slabGroups[slabName].push({
        [minProp]: parseFloat(slab[minProp]),
        [maxProp]: parseFloat(slab[maxProp]),
      });
    });

    // Validate each group of slabs with the same slabName
    for (const [slabName, slabs] of Object.entries(slabGroups)) {
      const actualName = nameMap[slabName] || slabName; // Lookup name by ID, fallback to slabName if not found

      if (slabs.length > 1) {
        // Sort slabs by the minimum property to facilitate range checks
        slabs.sort((a, b) => a[minProp] - b[minProp]);

        // Check for same min and max values among duplicates
        const firstSlab = slabs[0];
        const allSameRange = slabs.every(
          (slab) =>
            slab[minProp] === firstSlab[minProp] &&
            slab[maxProp] === firstSlab[maxProp]
        );
        if (allSameRange) {
          this.sharedService.showMessageDialog(
            `Duplicate slab "${actualName}" with identical ${minProp} and ${maxProp} values.`,
            '',
            SweetAlertIcon.WARNING
          );
          return false;
        }

        // Check for overlapping or adjacent ranges in the sorted slabs
        for (let i = 1; i < slabs.length; i++) {
          const prevSlab = slabs[i - 1];
          const currentSlab = slabs[i];

          if (
            currentSlab[minProp] >= prevSlab[minProp] &&
            currentSlab[minProp] <= prevSlab[maxProp]
          ) {
            this.sharedService.showMessageDialog(
              `Overlapping or adjacent range detected for slab "${actualName}".`,
              '',
              SweetAlertIcon.WARNING
            );
            return false;
          }
          if (
            currentSlab[maxProp] >= prevSlab[minProp] &&
            currentSlab[maxProp] <= prevSlab[maxProp]
          ) {
            this.sharedService.showMessageDialog(
              `Overlapping or adjacent range detected for slab "${actualName}".`,
              '',
              SweetAlertIcon.WARNING
            );
            return false;
          }
        }
      }
    }

    // If validation passes
    return true;
  }

  triSourceItems: any;
  isAllUtilitiesEmpty(): boolean {
    const gasGroup = this.utilitiesForm.get('gas') as FormGroup;

    const hasGasValue =
      gasGroup &&
      gasGroup.enabled &&
      (
        gasGroup.get('gasValue')?.value ||
        gasGroup.get('UnitLPGValue')?.value ||
        gasGroup.get('unitPrice')?.value
      );

    const hasWater =
      (this.utilitiesForm.get('water') as FormArray)?.length > 0;

    const hasElectricity =
      (this.utilitiesForm.get('electricity') as FormArray)?.length > 0;

    const hasTriSource =
      (this.utilitiesForm.get('trisources') as FormArray)?.length > 0;

    return !hasGasValue && !hasWater && !hasElectricity && !hasTriSource;
  }

  onSave(): void {

    if (this.isAllUtilitiesEmpty()) {
      this.sharedService.showMessageDialog(
        'Validation Error',
        'Please add at least one utility (Gas, Water, Electricity, or TriSource) before saving.',
        SweetAlertIcon.WARNING
      );
      return;
    }
    this.submitted = true;

    if (this.utilitiesForm.valid) {
      console.log(this.utilitiesForm.value);

      const isWaterValid = this.validateSlabData(
        this.utilitiesForm.value.water,
        this.waterTypeItems,
        'MinValue',
        'MaxValue'
      );

      if (!isWaterValid) {
        console.log('Water slab data has issues');
        return;
      }

      const isElectricityValid = this.validateSlabData(
        this.utilitiesForm.value.electricity,
        this.electricityTypeItems,
        'minKwh',
        'maxKwh'
      );

      if (!isElectricityValid) {
        console.log('Electricity slab data has issues');
        return;
      }
      const isTraiSourceValid = this.validateSlabData(
        this.utilitiesForm.value.trisources,
        this.triSourceItems,
        'minKwh',
        'maxKwh'
      );

      if (!isTraiSourceValid) {
        console.log('TriSource slab data has issues');
        return;
      }

      this.submitted = false;

      // Get raw form values without mutating
      const utilitiesData = this.ensureUtilityMasterIds(
        this.utilitiesForm.getRawValue()
      );
      console.log(this.utilitiesForm.getRawValue());

      // Create a mutable clone of the object to work on
      const clonedData = { ...utilitiesData };

      // Extract files from Kendo Upload components
      const gasFileControl = this.utilitiesForm.get('gas.File');
      const electricityFileControl = this.utilitiesForm.get('ElectricityFile');
      const waterFileControl = this.utilitiesForm.get('WaterFile');
      const triSourceFileControl = this.utilitiesForm.get('triSourceFile');
      if (
        gasFileControl &&
        gasFileControl.value &&
        gasFileControl.value.length > 0
      ) {
        clonedData.gas.File = gasFileControl.value[0].rawFile; // Extract raw gas file
      }

      if (
        electricityFileControl &&
        electricityFileControl.value &&
        electricityFileControl.value.length > 0
      ) {
        clonedData.ElectricityFile = electricityFileControl?.value[0]?.rawFile; // Extract raw electricity file
      }
      if (
        triSourceFileControl &&
        triSourceFileControl.value &&
        triSourceFileControl.value.length > 0
      ) {
        clonedData.triSourceFile = triSourceFileControl?.value[0]?.rawFile; // Extract raw electricity file
      }

      if (
        waterFileControl &&
        waterFileControl.value &&
        waterFileControl.value.length > 0
      ) {
        clonedData.WaterFile = waterFileControl.value[0].rawFile; // Extract raw water file
      }

      console.log('clonedData===================', clonedData);

      // return
      this.store.dispatch(
        createutilities({
          utilitiesData: clonedData,
        })
      );
    }
  }

  removeGasFileEventHandler(e: any): void {
    this.utilitiesForm.patchValue({ IsGasFileDeleted: true });
  }
  uploadGasFileEventHandler(event: any): void {
    const allowedExtensions = ['pdf', 'png', 'jpg', 'jpeg', 'xls', 'xlsx'];
    const files = event.files;

    if (!files || files.length === 0) {
      return; // No files to process
    }

    for (const file of files) {
      const extension = file.name.split('.').pop().toLowerCase();
      if (!allowedExtensions.includes(extension)) {
        event.preventDefault(); // Prevent the upload
        this.isUploading = false;
        this.sharedService.showMessageDialog(
          `${file.name}`,
          `Oops! It looks like you're trying to upload a video. Only images are allowed (PDF, PNG, JPG, JPEG, XLS, XLSX). Please select a supported file. `,
          SweetAlertIcon.WARNING
        );

        // alert(`Invalid file type: ${file.name}. Please upload a valid file (PDF, PNG, JPG, JPEG, XLS, XLSX).`);
        return; // Exit the loop after the first invalid file
      }
    }

    // Proceed with the upload if all files are valid
    this.isUploading = true;
    this.utilitiesForm.patchValue({ IsGasFileDeleted: false });
  }

  removeWaterFileEventHandler(e: any): void {
    this.utilitiesForm.patchValue({ IsWaterFileDeleted: true });
  }
  uploadWaterFileEventHandler(event: any): void {
    const allowedExtensions = ['pdf', 'png', 'jpg', 'jpeg', 'xls', 'xlsx'];
    const files = event.files;

    if (!files || files.length === 0) {
      return; // No files to process
    }

    for (const file of files) {
      const extension = file.name.split('.').pop().toLowerCase();
      if (!allowedExtensions.includes(extension)) {
        event.preventDefault(); // Prevent the upload
        this.isUploading = false;
        this.sharedService.showMessageDialog(
          `${file.name}`,
          `Oops! It looks like you're trying to upload a video. Only images are allowed (PDF, PNG, JPG, JPEG, XLS, XLSX). Please select a supported file. `,
          SweetAlertIcon.WARNING
        );

        // alert(`Invalid file type: ${file.name}. Please upload a valid file (PDF, PNG, JPG, JPEG, XLS, XLSX).`);
        return; // Exit the loop after the first invalid file
      }
    }

    // Proceed with the upload if all files are valid
    this.isUploading = true;
    this.utilitiesForm.patchValue({ IsWaterFileDeleted: false });
  }

  removeEleFileEventHandler(e: any): void {
    this.utilitiesForm.patchValue({ IsElectricityFileDeleted: true });
  }

  removeTriSourceFileEventHandler(e: any): void {
    this.utilitiesForm.patchValue({ IsTriSourceFileDeleted: true });
  }
  uploadEleFileEventHandler(event: any): void {
    const allowedExtensions = ['pdf', 'png', 'jpg', 'jpeg', 'xls', 'xlsx'];
    const files = event.files;

    if (!files || files.length === 0) {
      return; // No files to process
    }

    for (const file of files) {
      const extension = file.name.split('.').pop().toLowerCase();
      if (!allowedExtensions.includes(extension)) {
        event.preventDefault(); // Prevent the upload
        this.isUploading = false;
        this.sharedService.showMessageDialog(
          `${file.name}`,
          `Oops! It looks like you're trying to upload a video. Only images are allowed (PDF, PNG, JPG, JPEG, XLS, XLSX). Please select a supported file. `,
          SweetAlertIcon.WARNING
        );

        // alert(`Invalid file type: ${file.name}. Please upload a valid file (PDF, PNG, JPG, JPEG, XLS, XLSX).`);
        return; // Exit after finding the first invalid file
      }
    }

    // Proceed with the upload if all files are valid
    this.isUploading = true;
    this.utilitiesForm.patchValue({ IsElectricityFileDeleted: false });
  }

  uploadTriSourceFileEventHandler(event: any): void {
    const allowedExtensions = ['pdf', 'png', 'jpg', 'jpeg', 'xls', 'xlsx'];
    const files = event.files;

    if (!files || files.length === 0) {
      return; // No files to process
    }

    for (const file of files) {
      const extension = file.name.split('.').pop().toLowerCase();
      if (!allowedExtensions.includes(extension)) {
        event.preventDefault(); // Prevent the upload
        this.isUploading = false;
        alert(
          `Invalid file type: ${file.name}. Please upload a valid file (PDF, PNG, JPG, JPEG, XLS, XLSX).`
        );
        return; // Exit after finding the first invalid file
      }
    }

    // Proceed with the upload if all files are valid
    this.isUploading = true;
    this.utilitiesForm.patchValue({ IsTriSourceFileDeleted: false });
  }

  public onSuccess(): void {
    this.isUploading = false;
  }

  add_UMD() {
    let configData = this.configData;
    this.modalRef = this.modalService.show(RpCreateUMDComponent, {
      initialState: { configData },
      ...this.config,
    });
  }
  openBulkUploadEV() {
    let pageData = {
      title: Templates.EVUTILITYMEASURINGDEVICES.id,
      projectId: this.projectId,
    };
    this.modalRef = this.modalService.show(RpBulkUpoadComponent, {
      initialState: { pageData },
      ...this.config,
    });

    this.modalRef.content.output.subscribe((response: any) => {
      console.log('Bulk upload EV response:', response);
      if (response == 'renderNewData') {
        // Clear loader and refresh UMD data. Do not close SweetAlert here,
        // allow the upload component to show its success dialog.
        this.loaderService.setLoading(false);
        this.getAllUmd();
      }
    });
  }
  openBulkUpload() {
    let pageData = { title: Templates.UMD.id, projectId: this.projectId };
    this.modalRef = this.modalService.show(RpBulkUpoadComponent, {
      initialState: { pageData },
      ...this.config,
    });
    // this.modalRef = this.modalService.show(RpUserProfileComponent, { initialState: { profileData }, class: 'modal-lg' });

    this.modalRef.content.output.subscribe((response: any) => {
      console.log('Profile data received in header:', response);
      if (response == 'renderNewData') {
        this.getAllUmd();
      }
      // Handle the received profile data here
    });
  }

  public onUmdPdfExport(type: string) {
    // if (this.mySelectionUmd.length == 0) {
    //   this.getAllTotalUmd();
    // }
    if (type === 'Excel') {
      if (this.umdgridData.data.length > 0) {
        setTimeout(() => {
          this.hiddenUmdGrid?.saveAsExcel();
        }, 1000);
      } else {
        this.sharedService.showMessageDialog(
          'No data to display',
          '',
          SweetAlertIcon.ERROR
        );
      }
    } else if (type === 'Pdf') {
      setTimeout(() => {
        this.hiddenUmdGrid?.saveAsPDF();
      }, 1000);
    }
  }
  public onElectricCityPdfExport(type: string) {
    // this.hiddenGrid?.saveAsPDF();
    // if (this.myElectricTable_SelectionUmd.length == 0) {
    //   this.GetAllElectricityStatus();
    // }
    if (type === 'Excel') {
      if (this.electric_city_gridData.data.length > 0) {
        setTimeout(() => {
          this.hiddenElectricGrid?.saveAsExcel();
        }, 1000);
      } else {
        this.sharedService.showMessageDialog(
          'No data to display',
          '',
          SweetAlertIcon.ERROR
        );
      }
    } else if (type === 'Pdf') {
      setTimeout(() => {
        this.hiddenElectricGrid?.saveAsPDF();
      }, 1000);
    }
  }

  onUmdSortChange(sort: SortDescriptor[]): void {
    this.umd_state.sort = sort;
    console.log(this.umd_state.sort);
    const orderByQuery = this.sharedService.createOrderByQuery(
      this.umd_state.sort
    );

    this.umdOrderByQuery = orderByQuery;

    this.getAllUmd();
  }

  public onUmdFilterChange(filter: CompositeFilterDescriptor): void {
    this.umd_state.filter = filter;
    console.log(this.umd_state);
    this.skip = 0;
    const queryString = this.sharedService.createQuery(this.umd_state);
    this.umdQueryString = this.sharedService.createQuery(this.umd_state);
    this.getAllUmd();
    console.log(queryString);
  }

  public customFilterState: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };
  customDateFiltersQueryEq: any[] = [];
  customDateFiltersQueryNEQ: any[] = [];
  async onElectricityFilterChange(filter: CompositeFilterDescriptor) {
    this.electricityState.filter = filter;
    this.customFilterState = {
      skip: 0,
      take: 10,
      filter: {
        logic: 'and',
        filters: [],
      },
    };
    this.customFilterState = _.cloneDeep(this.electricityState);
    var filterOperators = await this.sharedService.togetFilterOperators(
      this.electricityState
    );
    //  console.log("temp-------------->", filterOperators)
    const iscustomdates = filterOperators?.filter((filter: any) => {
      return filter.value instanceof Date;
    });

    let isEq: any;
    let isNeq: any;
    this.customDateFiltersQueryEq = [];
    this.customDateFiltersQueryNEQ = [];

    if (iscustomdates && iscustomdates.length > 0) {
      isEq = iscustomdates.filter((filter: any) => filter.operator === 'eq');
      isNeq = iscustomdates.filter((filter: any) => filter.operator === 'neq');

      if (isEq.length > 0) {
        this.customDateFiltersQueryEq =
          this.sharedService.customizeFilterQueryEQ(isEq);
        // console.log("gasQueryString", this.customDateFiltersQueryEq)
      }
      if (isNeq?.length > 0) {
        isNeq.forEach((item: any) => {
          this.customDateFiltersQueryNEQ =
            this.sharedService.customizeFilterQueryNEQ(isNeq);
          // console.log("gasQueryString", this.customDateFiltersQueryNEQ)
        });
      }
    } else {
      isNeq = undefined;
      isEq = undefined;
      this.customDateFiltersQueryEq = [];
      this.customDateFiltersQueryNEQ = [];
    }
    if (
      this.customDateFiltersQueryEq.length > 0 ||
      this.customDateFiltersQueryNEQ.length > 0
    ) {
      let customFilterQueryString =
        await this.sharedService.newmodifyFilterJson(
          this.customFilterState,
          this.customDateFiltersQueryEq,
          this.customDateFiltersQueryNEQ
        );
      this.electricity_QueryString = this.sharedService.dateFiltercreateQuery(
        customFilterQueryString
      );
    } else {
      this.electricity_QueryString = this.sharedService.createQuery(
        this.customFilterState
      );
    }

    this.electricitypage = 1;
    this.skip = 0;
    this.GetElectricityStatus();

    //console.log(this.electricity_QueryString);
  }

  onElectricitySortChange(sort: SortDescriptor[]): void {
    this.electricityState.sort = sort;
    console.log(this.electricityState.sort);
    const orderByQuery = this.sharedService.createOrderByQuery(
      this.electricityState.sort
    );

    this.electricity_OrderByQuery = orderByQuery;

    this.GetElectricityStatus();
  }

  protected umdPageChange({ skip, take }: PageChangeEvent): void {
    this.mySelectionUmd = [];
    console.log('>>>', skip, take);
    this.skip = skip;
    this.pageSize = take;
    this.currentPage = Math.floor(skip / take) + 1;
    console.log('currentpage', Math.floor(skip / take) + 1);
    this.getAllUmd();
    this.loadUmd();
  }

  protected electricCityPageChange({ skip, take }: PageChangeEvent): void {
    this.myElectricTable_SelectionUmd = [];
    console.log('>>>', skip, take);
    this.skip = skip;
    this.electricity_pageSize = take;
    this.electricitypage = Math.floor(skip / take) + 1;
    console.log('currentpage', Math.floor(skip / take) + 1);
    this.GetElectricityStatus();
    // this.loadElectricCity();
  }

  public selectionChanged(selection: any) {
    // Handle deselected rows
    selection.deselectedRows.forEach((row: any) => {
      const index = this.mySelectionUmd.findIndex(
        (selectedRow: any) => selectedRow.id === row.dataItem.id
      );
      if (index > -1) {
        this.mySelectionUmd.splice(index, 1);
      }
    });

    // Handle selected rows
    selection.selectedRows.forEach((row: any) => {
      if (!this.isMasterRowSelected(row.dataItem)) {
        this.mySelectionUmd.push(row.dataItem);
      }
    });

    console.log(this.mySelectionUmd);
  }

  public electric_selectionChanged(selection: any) {
    // Handle deselected rows
    selection.deselectedRows.forEach((row: any) => {
      const index = this.myElectricTable_SelectionUmd.findIndex(
        (selectedRow: any) => selectedRow.id === row.dataItem.id
      );
      if (index > -1) {
        this.myElectricTable_SelectionUmd.splice(index, 1);
      }
    });

    // Handle selected rows
    selection.selectedRows.forEach((row: any) => {
      if (!this.isElectricRowSelected(row.dataItem)) {
        this.myElectricTable_SelectionUmd.push(row.dataItem);
      }
    });

    console.log(this.myElectricTable_SelectionUmd);
  }

  onSearchElectricCityStatus(): void {
    this.triggerSearchele();
    /* if (this.electriCitySearch.length > 0) {
      this.GetElectricityStatus();
    } */
  }

  public isElectricRowSelected = (rowArg: any) => {
    return this.myElectricTable_SelectionUmd.some(
      (row: any) => row.id === rowArg.id
    );
  };

  public isMasterRowSelected = (rowArg: any) => {
    return this.mySelectionUmd.some((row: any) => row.id === rowArg.id);
  };

  protected dataStateChange(state: DataStateChangeEvent): void {
    this.sort = state.sort || [];
    this.filter = state.filter || { logic: 'and', filters: [] };
    // this.loadUmd();
  }

  protected electric_dataStateChange(state: DataStateChangeEvent): void {
    this.sort = state.sort || [];
    this.filter = state.filter || { logic: 'and', filters: [] };
    this.electricity_pageSize = state.take;
    // this.GetElectricityStatus();
    this.loadElectricCity();
  }
}
